import ApiClient from "@common/api/ApiClient";

class ComplianceSessionClient extends ApiClient {
  constructor() {
    super("ComplianceSessions");
  }

  SessionsComplianceCMS = async (
    siteId = null,
    periodId = 0,
    pageNumber = 1,
    includeNonAlerts = true,
  ) =>
    await this.get(
      `alert/sessions/${siteId},${periodId},${pageNumber},${includeNonAlerts}`,
    );

  GetSessionsPositions = (siteId) => this.get(`Positions/${siteId}`);

  GetSessionsByGuids = async (sessionGuids, pageNumber = 1) =>
    await this.get(`Sessions/byguids/${sessionGuids.join(";")},${pageNumber}`);

  GetSessionsByIds = async (sessionIds, pageNumber = 1) =>
    await this.get(`Sessions/byids/${sessionIds.join(";")},${pageNumber}`);

  GetSessions = async (installationId, periodId, pageNumber) =>
    await this.get(`Sessions2/${installationId},${periodId},${pageNumber}`);
}

const client = new ComplianceSessionClient();

export default client;
